export function SystemMessages($) {
  const messges = $(".system-messages");

  messges &&
    messges.addEventListener("click", (event) => {
      if (event.target.dataset.close === "true") {
        event.target.parentNode.style.display = "none";
      }
    });
}
